import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";

interface TotalAmountProps {
  amount: number;
  counted?: number;
  period: string;
}

export const TotalAmount = ({ amount, counted }: TotalAmountProps) => {
  const { data: currency } = useOwnerCurrency();

  const formatAmount = (value: number) => {
    return `${value.toLocaleString()} ${currency}`;
  };

  return (
    <div className="space-y-2">
      {counted !== undefined && counted > 0 && (
        <div className="text-xl font-bold text-blue-600">
          Dernier montant compté: {formatAmount(counted)}
        </div>
      )}
    </div>
  );
};